import Card from './Card';

/**
 * StatCard — the KPI/metric tile used on Dashboard, Alerts, Admin, etc.
 * Reproduces the hand-built KPI card (uppercase label + icon tile + big
 * Cormorant number + subtext) as one token-driven primitive.
 *
 * Props:
 *   label   — small uppercase caption
 *   value   — the metric (string or number)
 *   sub     — supporting line under the value
 *   tone    — accent hex (drives number colour + icon tile tint). Default ink.
 *   icon    — a react-icons component (rendered inside the tile)
 *   compact — smaller number size (for long values like currency)
 */
export default function StatCard({ label, value, sub, tone = '#08111f', icon: Ico, compact = false, className = '', ...rest }) {
  return (
    <Card hover className={`flex flex-col gap-2 ${className}`} {...rest}>
      <div className="flex items-center justify-between gap-2">
        <div className="text-[10px] uppercase tracking-[1.2px] text-[#7a7060] font-semibold">{label}</div>
        {Ico && (
          <div
            className="w-7 h-7 flex items-center justify-center shrink-0"
            style={{ background: `${tone}1a`, color: tone, borderRadius: 'var(--r-md)' }}
          >
            <Ico size={15} />
          </div>
        )}
      </div>
      <div
        className={`${compact ? 'text-[26px]' : 'text-[40px]'} leading-none font-bold`}
        style={{ color: tone, fontFamily: 'var(--font-serif)' }}
      >
        {value}
      </div>
      {sub && <div className="text-[11px] text-[#7a7060]">{sub}</div>}
    </Card>
  );
}
